import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, combineLatest, of, tap } from 'rxjs';
import { Token, TokenStorageService } from '../../../services/token-storage/token-storage.service';
import { LOCAL_STORAGE_REDIRECT_URL } from '../../../constants';
import { LoggerService } from '../../../services/logger.service';

@Component({
    selector: 'app-entry',
    imports: [],
    template: ``
})
export class EntryComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private tokenService = inject(TokenStorageService);
  private logger = inject(LoggerService);

  ngOnInit(): void {
    const params$ = combineLatest([this.route.queryParamMap, this.route.fragment]);
    params$.pipe(
      tap(([params, fragment]) => {
        this.logger.log('EntryComponent', 'ngOnInit', 'params', params, fragment);
        // Get expiration timestamp from query params
        const expirationParam = params.get('exp');
        const expirationTimestamp = expirationParam ? parseInt(expirationParam, 10) : undefined;
        // Create token with access_token and expiration
        this.tokenService.setToken({
          access_token: fragment as string,
          expiration_timestamp: expirationTimestamp
        } as Token);
        let action;
        action = params.get('action');

        if (action) {
          this.logger.log('EntryComponent', 'ngOnInit', 'action', action);
          localStorage.setItem(LOCAL_STORAGE_REDIRECT_URL, action);
          this.router.navigate([action]);
          return;
        }
        const existingRedirect = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL);
        if (existingRedirect != null) {
          localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URL);
          this.router.navigate([existingRedirect]);
          return;
        }
      }),
      catchError(err => {
        this.logger.error('Error in EntryComponent', 'ngOnInit', 'params', err);
        return of([])
      })
    ).subscribe(() => this.router.navigate(['/login']));
  }
}
